export const phonePlaceholders = {
    en: '+1 (000) 000-0000',
    ua: '+380 (00) 000 00 00',
};

export const phoneCountries = {
    en: 'us',
    uk: 'ua',
};
